import { render, staticRenderFns } from "./LedgerReport.vue?vue&type=template&id=3bad5194"
import script from "./LedgerReport.vue?vue&type=script&lang=js"
export * from "./LedgerReport.vue?vue&type=script&lang=js"
import style0 from "./LedgerReport.vue?vue&type=style&index=0&id=3bad5194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports